import moment from 'moment';
const apiUrl = process.env.REACT_APP_API_URL;

/**
 * Loads reviews from a separate chunk via dynamic import.
 * @returns {Promise<Array>} The array of review objects.
 */
export async function reviews() {
  const data = await import('./reviews.json');
  return data.default || data;
}

export async function specials() {
  let response = await fetch('https://'+apiUrl+'/specials');
  let data = await response.json();
  // filter the given dictionary specials, so that only those items remain 
  // where fromDate >= today and today between validFrom and validTo
  const specialsActive = data.Items.filter(
      (special) => {
        const today = new Date().toISOString().split('T')[0];
        return (
          special.validFrom<=today && special.validTo >= today
        );
      }
  );
  return specialsActive;
}

export async function seasons() {
  let response = await fetch('https://'+apiUrl+'/configs');
  let data = await response.json();
  return data.Items;
}

export async function blockedDates(/*f, err, camperId*/) {
  //console.log('function: load blocked dates: ');
  let response = await fetch('https://'+apiUrl+'/unavailable-dates');
  let data = await response.json();
  //console.log('got blockedDates', data);
  return data;
 //f(data, camperId);
      // .then(res => {
      //   return res.json();
      // })
      // .then(data => {
      //   ////console.log(data);
      //   f(data, camperId);
      // },
      // // Note: it's important to handle errors here
      // // instead of a catch() block so that we don't swallow
      // // exceptions from actual bugs in components.
      // (error) => {
      //   err(error);
      //   //console.log(error);
      // });
}

export async function campers(/*f, err*/) {
  let response = await fetch('https://'+apiUrl+'/campers');
  let data = await response.json();
  return data.Items;
}

export function PostBookingRequest(params) {
  let apiUrl = 'https://o95nosfn1a.execute-api.eu-central-1.amazonaws.com/dev';
  const searchParams = Object.keys(params).map((key) => {
          return encodeURIComponent(key) + '=' + encodeURIComponent(params[key]);
        }).join('&');
  fetch(apiUrl, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
    },
    body: searchParams
  });
}

// export {
//   Translations,
// };
